import { useState, useEffect, useRef } from 'react'
import _ from 'lodash'

const doSearchThrottle = _.throttle(
  (onSearched, placeSearch, keyword, adcode) => {
    // console.log('搜索参数为: ', keyword, adcode);
    placeSearch.setCity(adcode || '全国')
    placeSearch.search(keyword, function (status, result) {
      if (status === 'complete') {
        if (result?.info === 'OK' && result?.poiList?.pois) {
          onSearched(result?.poiList?.pois)
        } else {
          onSearched([])
        }
      }
    })
  },
  1000
)

export default (props) => {
  const { __map__, keyword, adcode, onSearched, cityCode, lnglat } = props
  const [placeSearch, setPlaceSearch] = useState<any>(null)
  const [geocoder, setGeocoder] = useState<any>(null)
  const initedRef = useRef(false);

  useEffect(() => {
    // const st = Date.now();
    __map__.plugin(['AMap.PlaceSearch', 'AMap.Geocoder'], function () {
      // const now = Date.now();
      // console.info('获取 AMap.PlaceSearch, AMap.Geocoder 耗时为', (now - st) / 1000, 's');
      setPlaceSearch(
        new AMap.PlaceSearch({
          pageSize: 15,
          extensions: 'all',
          city: adcode || '440104',
        })
      )
      setGeocoder(
        new AMap.Geocoder({
          city: cityCode || '020', //城市设为北京，默认：“全国”
        })
      )
    })
  }, [adcode, cityCode])

  useEffect(() => {
    if (initedRef.current || !lnglat || !lnglat[0] || !lnglat[1]) return;
    if (!geocoder) return;
    geocoder.getAddress(lnglat, function(status, result) {
      // console.log('geocoder.getAddress ??????????? status, result', result);
      if (status === 'complete' && result.regeocode) {
        // console.log('初始化计算经纬度之后 resultresultresultresult', result);
        const { regeocode } = result
        const addressComp = regeocode.addressComponent;
        // const address = regeocode.formattedAddress;
        const fuzzyAddr = `${addressComp.district || ''}${addressComp.township || ''}${addressComp.street || ''}${addressComp.streetNumber || ''}`;
        console.log('模糊搜索地址为-------------', fuzzyAddr);
        doSearchThrottle(onSearched, placeSearch, fuzzyAddr, addressComp.adcode)
      } else{
        console.error('根据经纬度查询地址失败')
      }
      initedRef.current = true;
  });
  }, [lnglat, geocoder, placeSearch, onSearched]);

  useEffect(() => {
    if (placeSearch && keyword) {
      doSearchThrottle(onSearched, placeSearch, keyword, adcode)
    }
  }, [keyword, placeSearch, adcode])

  return null
}
